import React, { useEffect, useState } from 'react';
import ForumRoundedIcon from '@mui/icons-material/ForumRounded';
import { useDispatch } from 'react-redux';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from 'routes/Pages/constants/ActionTypes';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { useToast } from 'context/tostifyContext';
const enquiryIcons = <ForumRoundedIcon style={{ color: '#ffffff' }} />;
const useFormsHook = () => {
  const dispatch = useDispatch();
  const [fromPageData, setFormPageData] = useState([]);
  const { showToast } = useToast();

  //EnquiryFormData
  const [openEnquiryForm, setOpenEnquiryForm] = useState(false);
  const handleOpenEnquiryFormClick = () => {
    setOpenEnquiryForm(true);
  };
  useEffect(() => {
    let data = [
      {
        id: 4,
        cardTitle: 'Timber Enquiry Form',
        cardValue: null,
        cardHref: '/',
        icon: enquiryIcons,
        backgroundColor: 'rgb(41, 207, 107)',
        onClick: handleOpenEnquiryFormClick,
      },
    ];
    setFormPageData(data);
  }, []);
  const handleEnquiryformSubmit = async enquiryData => {
    try {
      let newCrmContact = {
        crmStageName: 'Enquiries',
        crmStageId: 1,
        crmContactTitle: enquiryData.title,
        crmContactFirst: enquiryData.enquirerName,
        crmContactMiddle: '',
        crmContactLast: '',
        crmLeadReferralSource: '',
        // crmDateOfInitialContact: '',
        crmTitle: '',
        crmCompany: '',
        crmIndustry: '',
        crmAddressLine1: enquiryData.homeAddress,
        crmAddressLine2: enquiryData.forestAddress,
        crmAddressCity: '',
        crmAddressTown: enquiryData.forestCounty,
        crmAddressZip: enquiryData.forestEircode,
        crmAddressCountry: '',
        crmContactPhone: enquiryData.phoneNumber,
        crmContactEmail: enquiryData.email,
        crmContactStatus: '',
        crmContactWebsite: '',
        crmLinkedInProfile: '',
        crmBackgroundInfo: '',
        crmSalesRep: null,
        crmRating: '',
        crmProjectType: '',
        crmProjectDescription: '',
        // crmProposalDueDate: '',
        crmBudget: null,
        crmDeliverable: null,
        crmDoNotContact: null,
        crmDoNotEmail: null,
        crmTeamId: 1,
        fellingLicenseNo: enquiryData.fellingLicenseNumber,
        dropPin: enquiryData.dropPin,
        dropPinLatitude: enquiryData.siteEntranceLatitude || 0,
        dropPinLongitude: enquiryData.siteEntranceLongitude || 0,
        leadQuality: enquiryData.enquiryRating,
      };
      const crmId = await addNewContact('/CRM/AddContact', newCrmContact);
      if (crmId) {
        enquiryData['crmId'] = crmId;
      }
      dispatch({ type: FETCH_START });
      await customAxios
        .post('/Enquiry/AddEnquiryDetails', enquiryData, { headers: authHeader() })
        .then(data => {
          setOpenEnquiryForm(false);
          showToast('Enquiry Added Successfully', 'success');
          dispatch({ type: FETCH_SUCCESS });
        })
        .catch(error => {
          dispatch({ type: FETCH_ERROR, payload: error.message });
        });
    } catch (Ex) {
      showToast('Fiailed to add enquiry', 'error');
      console.log(Ex);
    }
  };
  async function addNewContact(url, data) {
    return new Promise(async res => {
      try {
        dispatch({ type: FETCH_START });
        const response = await customAxios.post(url, data, { headers: authHeader() });
        if (response.status == 200) {
          dispatch({ type: FETCH_SUCCESS });
          res(response.data.crmId);
        } else {
          res(null);
        }
      } catch (error) {
        dispatch({ type: FETCH_ERROR, payload: error.message });
        res(null);
      }
    });
  }
  return {
    fromPageData,
    openEnquiryForm,
    setOpenEnquiryForm,
    handleOpenEnquiryFormClick,
    handleEnquiryformSubmit,
  };
};

export default useFormsHook;
